import React from 'react';
import { useReveal } from '../lib/useReveal';
const MODULES = ['Fundamentos del Reiki y activación energética', 'Cuerpo energético y sistema de chakras', 'Autosanación y práctica constante', 'Reiki Nivel II – Símbolos y dirección energética', 'Sanación a distancia y aplicación práctica', 'Nivel III – Maestría y profesionalización'];
export function HowItWorksSection() {
  const [ref1, vis1] = useReveal();
  const [ref2, vis2] = useReveal();
  return <section className="bg-[#2d1f3d] text-white py-24 md:py-32 px-4 relative overflow-hidden" data-id="element-222">
      <div className="absolute inset-0 opacity-5 bg-[radial-gradient(#ffffff_1px,transparent_1px)] [background-size:20px_20px]" data-id="element-223"></div>

      <div className="container mx-auto max-w-5xl relative z-10" data-id="element-224">
        <div ref={ref1} className={`reveal text-center mb-16 ${vis1 ? 'is-visible' : ''}`} data-id="element-225">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-6 leading-tight" data-id="element-226">
            Cómo está estructurada la formación
          </h2>
          <p className="text-xl text-amber-200/80 font-medium" data-id="element-227">
            Todo explicado de forma clara y progresiva.
          </p>
        </div>

        <div ref={ref2} className={`reveal grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 ${vis2 ? 'is-visible' : ''}`} data-id="element-228">
          {MODULES.map((title, idx) => <div key={idx} className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-8 hover:bg-white/10 transition-colors group relative overflow-hidden" style={{
          transitionDelay: `${idx * 100}ms`
        }} data-id="element-229">
              <div className="absolute -right-4 -top-4 text-8xl font-serif font-bold text-white/5 group-hover:text-white/10 transition-colors select-none pointer-events-none" data-id="element-230">
                {idx + 1}
              </div>

              <div className="relative z-10" data-id="element-231">
                <span className="inline-block text-amber-400 font-bold text-sm tracking-widest uppercase mb-3" data-id="element-232">
                  Módulo {idx + 1}
                </span>
                <h3 className="text-xl font-serif font-bold text-white leading-snug" data-id="element-233">
                  {title}
                </h3>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}